export default "__VITE_ASSET__9c30c9f5__"